import { useSelector } from 'react-redux';
import { Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import {
  AnalyticsEventNames,
  Categories,
  DataLayerEventName,
  pushToAdobeDataLayer,
} from '@app/services/adobeDataLayer';
import { PlanLink } from '@app/router/constants';
import { useNavigate } from '@app/hooks';
import { selectChangePlan } from '@app/redux';

import { GetPlanOffersPayload } from '@mfe/shared/schema-types';

import AvailablePlan from '../../../ChangePlan/components/AvailablePlans/AvailablePlan';
import Loading from '../../../ChangePlan/components/Loading';
import ConfirmationModal from './ConfirmationModal';

import styles from './index.module.scss';

const PlanOffers = ({
  handleSelect,
  isModalOpen,
  closeModal,
}: {
  handleSelect: () => void;
  isModalOpen: boolean;
  closeModal: () => void;
}) => {
  const { goTo } = useNavigate();
  const { t } = useTranslation('Disconnect');
  const { planOffersData, loading } = useSelector(selectChangePlan);

  const changePlanRoute = `${PlanLink.Plan}/${PlanLink.ChoosePlanFilter}`;
  const navigateToChangePlan = () => {
    pushToAdobeDataLayer({
      event: DataLayerEventName.PAGE_VIEW,
      event_name: DataLayerEventName.PAGE_VIEW,
      event_label: `${AnalyticsEventNames.SelectedPlan}`,
      event_category: Categories.Disconnect,
    });
    goTo(changePlanRoute);
  };

  const hasOffers = planOffersData && planOffersData?.length && planOffersData?.length > 0;

  return (
    <>
      {loading ? (
        <div className={styles['availablePlans']}>
          <Loading />
        </div>
      ) : hasOffers ? (
        <>
          <div>
            <Txt variant="bodyLargeBold">{t('planOffers.header')}</Txt>
            <Txt variant="bodySmallRegular" mt="8px">
              {t('planOffers.description')}
            </Txt>
          </div>

          <div className={styles['availablePlans']}>
            {planOffersData?.map((plan: GetPlanOffersPayload, i: number) => (
              <AvailablePlan key={i} plan={plan} handleClick={handleSelect} />
            ))}
          </div>
        </>
      ) : null}
      <ConfirmationModal isOpen={isModalOpen} handleCancel={closeModal} handleContinue={navigateToChangePlan} />
    </>
  );
};

export default PlanOffers;
